import {useContext} from 'react';
import StaffsContext from './staffs-context';

const useStaffs = () => {
  const context = useContext(StaffsContext);
  return context
};

export default useStaffs;
